import { LocalizationProvider as BaseLocalizationProvider } from 'localize-react'
import Language from '../models/Language'
import messages from './locales'
import { AppStore } from '../Store.js'

const LocalizationProvider = ({ children }) => {
  const appStore = AppStore;
  return (
    <BaseLocalizationProvider
      locale={appStore.language}
      defaultLocale={Language.he}
      translations={messages}
      disableCache
    >
      {children}
    </BaseLocalizationProvider>
  )
}

export default LocalizationProvider
